// OneDrive:CoverageThreshold(0)

import { addEventProps, EventBase, ClonedEventType, IEventProps, IEventType } from './EventBase';
import { IEvent, IEventMetadataDeclarationTable, IEventMetadataTable } from './IEvent';

export interface ISingleEvent<DataType> extends IEvent<DataType> {
    data: DataType;
}

export interface ISingleEventType<DataType> extends IEventType<DataType> {
    prototype: ISingleEvent<DataType>;
    logData(
        data: DataType,
        parent?: IEvent
    ): IEvent<DataType>;
}

export interface ISingleEventNoDataType extends IEventType<{}> {
    prototype: ISingleEvent<{}>;
    logData(
        parent?: IEvent
    ): IEvent<{}>;
}

function logData<T extends EventBase<DataType, DataType>, DataType>(this: { prototype: T }, data: DataType, parent?: IEvent): T {
    return new (this as { new(data: DataType, eventType: ClonedEventType, parent?: IEvent): T })(data, ClonedEventType.Single, parent);
}

function logEmptyData<T extends EventBase<{}, {}>>(this: { prototype: T }, parent?: IEvent): T {
    return new (this as { new(data: null, eventType: ClonedEventType, parent?: IEvent): T })(null, ClonedEventType.Single, parent);
}

export function createSingleEvent<SingleDataType>(props: IEventProps): ISingleEventNoDataType;
export function createSingleEvent<SingleDataType>(
    props: IEventProps,
    metadata: IEventMetadataDeclarationTable,
    baseClass?: {
        prototype: {
            metadata: IEventMetadataTable
        }
    }): ISingleEventType<SingleDataType>;
export function createSingleEvent<SingleDataType>(
    props: IEventProps,
    metadata?: IEventMetadataDeclarationTable,
    baseClass?: {
        prototype: {
            metadata: IEventMetadataTable
        }
    }): ISingleEventType<SingleDataType> | ISingleEventNoDataType {
    class SingleEvent extends EventBase<SingleDataType, SingleDataType> {
        // tslint:disable-next-line:typedef
        public static readonly logData = metadata ? logData : logEmptyData;
    }
    addEventProps(SingleEvent.prototype, props, metadata || {}, baseClass);

    return SingleEvent as ISingleEventType<SingleDataType> | ISingleEventNoDataType;
}
